import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const PaddingLeftRightIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M5 10H15M5 10L6.66667 7.5M5 10L6.66667 12.5M15 10L13.3333 7.5M15 10L13.3333 12.5M17.5 17.5V2.5M2.5 17.5V2.5"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
